import { createAction } from '@lifesize/typescript-react-redux-utils';

export enum MaxInactiveDaysActions {
  GET_INACTIVE_DAYS = 'GET_INACTIVE_DAYS',
  GET_ITEMS_TO_BE_DELETED = 'GET_ITEMS_TO_BE_DELETED',
  START_FETCHING_ITEMS_TO_BE_DELETED = 'START_FETCHING_ITEMS_TO_BE_DELETED',
  DONE_FETCHING_ITEMS_TO_BE_DELETED = 'DONE_FETCHING_ITEMS_TO_BE_DELETED'
}

export const actions = {
  getInactiveDays: () => createAction(MaxInactiveDaysActions.GET_INACTIVE_DAYS),
  getItemsToBeDeleted: (payload: object) => createAction(MaxInactiveDaysActions.GET_ITEMS_TO_BE_DELETED, payload),
  setBusyFetchingMeetingsToDelete: () => createAction(MaxInactiveDaysActions.START_FETCHING_ITEMS_TO_BE_DELETED),
  setNotBusyFetchingMeetingsToDelete: () => createAction(MaxInactiveDaysActions.DONE_FETCHING_ITEMS_TO_BE_DELETED)
};

export default actions;
